/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DropdownArrow from 'components/images/DropdownArrow';
import { LanguageWithCountryCodeOption, LanguageWithCountryCode, TranslatedLanguageWithCountryCodeOption, TranslatedLanguageWithCountryCode } from 'components/localization';
import listLocaleSelector from 'redux/reduxStore/lists/listLocale';
import userSelector from 'redux/reduxStore/user';

function mapStateToProps(state) {
  const localeList = listLocaleSelector.getCollection(state);
  const localeId = userSelector.getLocaleId(state);
  const preferredLocale = localeList.filter(l => l.id === localeId)[0] || {}
  return {
    preferredLocale,
  };
}

function withPreferredLocale(Component) {
  const ComponentWithPreferredLocale = (props) => (
    <Component {...props} />
  )

  return connect(mapStateToProps)(ComponentWithPreferredLocale)
}

export default withPreferredLocale;
